import { render } from "./UiSelect.vue?vue&type=template&id=14cae254&scoped=true&lang=pug"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"

import "./UiSelect.vue?vue&type=style&index=0&id=14cae254&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cae254"]])

export default __exports__